export enum PublicEventSsoAuthType {
  Undefined = 0,
  None = 1,
  Basic = 2,
  OAuth2ClientCredentials = 3
}
